import styled from "@emotion/styled"
import { waTriggerEvent } from "components/analytics/DigitalDataLayer"
import { useConfigurator } from "components/configurator-v3/context"
import { cssVars, useNav } from "components/nav-v2/Wrapper"
import { useConsole } from "contexts/Console"
import { useDictionary } from "contexts/Dictionary"
import getMediaQuery from "css/breakpoints"
import { buttonFilled, opaqueGreen } from "css/buttons"
import { bold, legend100 } from "css/text"
import { useMotionValueEvent } from "framer-motion"
import { useRef } from "react"

const Root = styled.div`
  --top: calc(var(${cssVars.main.safe}) + 1.38rem - 5rem * (1 - var(${cssVars.main.bar.pinned}, 0)));
  --opacity: var(${cssVars.main.bar.pinned});

  position: fixed;
  inset-inline: auto var(--outer-margin);
  inset-block: calc(var(--top)) auto;
  opacity: var(--opacity);
  z-index: 9990;

  & > :is(a, button) {
    ${buttonFilled}
    ${opaqueGreen}
    ${legend100}
    line-height: 1rem;
    transition: background 300ms;
    height: unset;

    & * {
      pointer-events: none;
    }

    display: flex !important;
    justify-content: center;
    align-items: center;
    white-space: nowrap !important;
    padding-block: 0.5rem !important;
    padding-inline: 0.88rem !important;
    align-items: center;
    border-radius: 0.375rem;

    & > svg {
      margin-inline: var(--gap) 0 !important;
    }

    html:not([dir="rtl"]) & svg {
      // transform: scaleX(-1);
    }

    & > span.link-content {
      ${legend100}
      ${bold}
      clip-path: initial;
      height: initial;
      overflow: initial;
      position: initial;
      white-space: nowrap;
      width: initial;
      display: none;
    }

    ${getMediaQuery("m")} {
      & > span.link-content {
        display: initial;
      }
    }
  }
`

const Configure = ({ children, ...props }) => {
  const console = useConsole()
  const nav = useNav()
  const rroot = useRef(null)
  const dictionary = useDictionary()
  const { route, page_type, launched } = useConfigurator()
  const rmcRegExp = /\/m[^-]*-[0-9]*$/g

  function onClick(e) {
    nav.collapseAll().then(() => {
      const currentLink = process.browser ? window.location.href : null
      const rmc = currentLink ? currentLink.match(rmcRegExp) : null
      waTriggerEvent({
        eventName: "ctaSubNav",
        eventType: "Click",
        ctaInfo: {
          name: "configure",
          url: currentLink,
        },
      })

      if (!props?.param || !currentLink) return
      let new_param = props.param
      if (rmc) {
        const fullpath = `${props.param}${rmc}`
        const index = currentLink.indexOf(fullpath)
        if (index < 0) return
        launched.set(true)
        new_param = `${fullpath}/*`
      }

      page_type.current = "family-subnav"
      route.set(new_param)
    })
  }

  useMotionValueEvent(nav.main.bar.motion.pinned, "change", latest => {
    const previous = nav.main.bar.motion.pinned.getPrevious()

    if (Number.isFinite(previous) || Number.isFinite(latest)) {
      rroot.current.inert = latest !== 1
    }
  })

  console.verbose("Nav:Configure(%o)", { props, nav })
  return (
    <Root ref={rroot}>
      <button type='button' aria-label={dictionary.ariaLabelOpenConfigurator()} onClick={onClick}>
        {props.label}
      </button>
    </Root>
  )
}

export default Configure
